package ui.app.assign.detail.wheel.editor.widgets

import androidx.compose.animation.Crossfade
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.Tab
import androidx.compose.material3.TabRow
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import org.jetbrains.compose.resources.StringResource
import tools.rememberString
import ui.app.assign.detail.wheel.editor.AppEditorWheelScope

@Composable
fun AppEditorWheelScope.MobileDualView(
    labelPrimary: StringResource,
    labelSecondary: StringResource,
    bodyPrimary: @Composable () -> Unit,
    bodySecondary: @Composable () -> Unit
) {
    var selection by remember {
        mutableStateOf(0)
    }
    Column(Modifier.fillMaxSize()) {
        Crossfade(
            targetState = selection,
            modifier = Modifier.fillMaxWidth()
                .weight(1F)
        ) {
            if (it == 0) bodyPrimary()
            else bodySecondary()
        }
        TabRow(
            selectedTabIndex = selection,
            modifier = Modifier.fillMaxWidth()
        ) {
            Tab(
                selected = selection == 0,
                onClick = { selection = 0 },
                text = { Text(labelPrimary.rememberString()) }
            )
            Tab(
                selected = selection == 1,
                onClick = { selection = 1 },
                text = { Text(labelSecondary.rememberString()) }
            )
        }
    }
}